import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'

const ContactUsComp = () => {
  return (
    <div>
      <NavBar/>
      <ContactUs/>
      <Footer/>
      
    </div>
  )
}

export default ContactUsComp
